import styled from 'styled-components';
import TermsAndConditionsModal from './TermsAndConditionsModal';
import { colorSchema } from 'utils/style';

export default styled(TermsAndConditionsModal)`
  .terms-and-conditions-modal {
    &__content {
      width: 28rem;
    }
    &__title {
      font-weight: bold;
      font-size: 2.4rem;
      color: ${colorSchema('grey900')};
    }
    &__link {
      color: ${colorSchema('primary500')};
      margin: 0 0.4rem;
      &:hover {
        text-decoration: underline;
      }
    }
    &__loading {
      display: flex;
      justify-content: center;
    }
    &__buttons {
      display: flex;
      justify-content: flex-end;
    }
    &__accept {
      margin-left: 1.6rem;
    }
  }
`;
